<template>
  <div class="enterprise-list-page enterprise-list-page--used-services">

    <!-- Header Card -->
        <PageHeader icon="fas fa-box-open">
      <template #title>
        Daftar Deposit Pemakaian Layanan
      </template>
      <template #subtitle>
        Tinjau sisa saldo deposit dan riwayat pemakaian paket layanan pasien
      </template>
    </PageHeader>

    <!-- Component List -->
    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <Table purpose="master" :source="0" />
          </template>
        </Card>
      </div>
    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import Table from '@/component/masters/payment-categories/TableUsedItem.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Table
  },

  data() {
    return {
      btn: false,
      btnAddDoctorCommission: false
    }
  },

  methods: {

    setActiveButton() {
      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for (a = 0; a < access_right.length; a++) {
        if (access_right[a] == "6009") {
          this.btn = true
        }        
      }
    },

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Layanan", },
      { title: "Daftar Deposit Pemaikaian Layanan" },
    ])
    this.setActiveButton()
  },

}

</script>
